import { ReactNode } from "react";
import {
  FormLabel,
  FormDescription,
  FormField,
  FormItem,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { ImageUpload } from "./ImageUpload";

interface InputFieldContainerProps {
  label: string;
  description?: string;
  control: any;
  name: string;
  render?: any;
  variant?: "default" | "two-column";
}

export default function InputFieldContainer({
  label,
  description,
  control,
  name,
  render,
  variant = "default",
}: InputFieldContainerProps) {
  if (variant === "two-column") {
    return (
      <div className="grid grid-cols-2 items-center gap-4">
        {label.length > 0 && (
          <FormLabel className="text-right">
            {label}
            {description && (
              <FormDescription className="text-right text-xs pt-1 font-light">
                {description}
              </FormDescription>
            )}
          </FormLabel>
        )}
        <FormField control={control} name={name} render={render} key={name} />
      </div>
    );
  }

  return (
    <div className="grid grid-cols-4 items-start gap-4">
      {label.length > 0 && (
        <FormLabel className="text-right pt-3">
          {label}
          {description && (
            <FormDescription className="text-right text-xs pt-2 font-light">
              {description}
            </FormDescription>
          )}
        </FormLabel>
      )}
      <FormField control={control} name={name} render={render} key={name} />
    </div>
  );
}
